"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useQuery } from "@tanstack/react-query";
import { appArticleList } from "@/entities";
import { NewsCardBase } from "@/entities/dev/news/ui/NewsCardBase";

export function Press() {
  const slug = "news";
  const state = "active";
  const common_category_id = "";
  const keyword = "";
  const page = 1;
  const perPage = 6;
  const filterParams = { state, common_category_id, keyword };

  const { error, isLoading, data } = useQuery({
    queryKey: [`app-articles`, { ...filterParams, slug, page, perPage }],
    queryFn: () => appArticleList({ ...filterParams, slug, page, perPage }),
  });

  if (error) return <></>;
  if (isLoading) return <></>;

  return (
    <div className="w-full flex flex-col my-20 md:my-40">
      <div className="xl:max-w-[1280px] mx-auto w-full px-5 xl:px-0 flex justify-between items-center mb-6 md:mb-20">
        <p
          className="md:text-4xl md:leading-14 tracking-tight text-xl leading-8 text-black-almostBlack"
          style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
        >
          활동소식
        </p>
        <Link
          href={`/app/news`}
          className="md:text-2xl md:leading-9 text-base leading-7 tracking-tight underline text-black-200"
          style={{ fontFamily: '"pre-Regular", sans-serif' }}
        >
          전체보기
        </Link>
      </div>

      <div className="md:w-full md:max-w-7xl md:mx-auto px-5 xl:px-0 overflow-hidden ">
        {data?.count && data?.count > 0 ? (
          <>
            {/* 1. 모바일 (md: 미만): 스와이프 기능 활성화 */}
            <ul className="flex flex-wrap gap-6">
              {data?.result.map((item: any, index: number) => (
                <li
                  key={index}
                  className={`
                  w-[calc((100%-24px)/2)] 
                  min-[763px]:w-[calc((100%-24px)/2)] 
                  min-[992px]:w-[calc((100%-48px)/3)]
                  max-[762px]:w-full
                  rounded-lg flex-shrink-0
                  mb-5
                `}
                >
                  <NewsCardBase item={item} />
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p
            className="my-30 text-center tracking-tight text-lightGray-10"
            style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
          >
            등록된 데이터가 없습니다.
          </p>
        )}
      </div>
    </div>
  );
}
